import React, { useEffect, useState } from "react";

import { siteLocationPrefix } from "../../constants";
import * as styles from "./TestStyle.module.css";

export const TestRedisDisplay = () => {
  const [redisData, setRedisData] = useState<Record<string, string> | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | undefined>(undefined);

  const fetchRedisData = async () => {
    setLoading(true);
    setError(undefined);
    try {
      const response = await fetch(`${siteLocationPrefix}/test/dumpRedis`);
      if (response.status !== 200) {
        setError(`Failed to fetch Redis data (${response.status})`);
        return;
      }
      const data = await response.json();
      setRedisData(data);
    } catch (e) {
      setError((e as Error).message);
    } finally {
      setLoading(false);
    }
  };

  const flushRedis = async () => {
    try {
      const response = await fetch(`${siteLocationPrefix}/test/flushRedis`);
      if (response.status === 200) {
        await fetchRedisData();
      } else {
        setError(`Flush failed (${response.status})`);
      }
    } catch (e) {
      setError((e as Error).message);
    }
  };

  useEffect(() => {
    fetchRedisData();
  }, []);

  const keys = redisData ? Object.keys(redisData) : [];

  return (
    <div className={styles.crmDataDisplay}>
      <h3>Redis Contents</h3>
      <div className={styles.crmDataListWrapper}>
        <div className={styles.crmDataListButtons}>
          <button className={styles.testButton} onClick={fetchRedisData}>
            Refresh
          </button>
          <button className={styles.testButtonDanger} onClick={flushRedis}>
            Flush All
          </button>
        </div>
        <div className={styles.forms}>
          {loading && <div>Loading Redis data...</div>}
          {error && <div>Error: {error}</div>}
          {!loading && !error && keys.length === 0 && <div>Redis is empty</div>}
          {!loading &&
            !error &&
            keys.map(key => (
              <div key={key} className={styles.container}>
                <strong>{key}</strong>
                <pre>{redisData?.[key]}</pre>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};
